// @ts-nocheck
import { Plugin } from '/home/runner/work/riveroll-workbench/riveroll-workbench/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','locale','layout','layoutActionRef','request',],
});

export { plugin };
